import { fullSettlement } from "@api/stores/customers/salesInvoices/fullSettlement/path";
import { summery } from "@api/stores/customers/salesInvoices/summery/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/:customerId/sales-invoices`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesInvoices = {
  getAll: apiPathFunc(pathBase),
  fullSettlement,
  summery,
};
